interface StorageData {
  access_token: string;
  refresh_token: string;
  user: {
    id: number;
    phone_no: string;
    is_verified: boolean;
    is_patient: boolean;
    name?: string;
    preferred_name?: string;
    email?: string;
    age?: string;
    date_of_birth?: string;
    gender?: string;
    country?: string;
    clinic_id?: number;
    is_admin?: boolean;
    is_super_admin?: boolean;
    is_medical_officer?: boolean;
    medical_officer_registration_number?: string;
  };
  session: {
    id: number;
    status: string;
    start_time: string;
    magic_link_session_id?: number;
    patient_id?: number;
    specialty?: string;
    practitioner_type?: string;
    language?: string;
    multilingual_consult?: boolean;
  };
}

const AUTH_KEY = 'auth_data';

export const storage = {
  setAuthData(data: StorageData) {
    localStorage.setItem(AUTH_KEY, JSON.stringify(data));
  },

  getAuthData(): StorageData | null {
    const data = localStorage.getItem(AUTH_KEY);
    return data ? JSON.parse(data) : null;
  },

   clearAuthData() {
    localStorage.removeItem(AUTH_KEY);
  },

  getAccessToken(): string | null {
    const data = this.getAuthData();
    return data ? data.access_token : null;
  },

  getRefreshToken(): string | null {
    const data = this.getAuthData();
    return data ? data.refresh_token : null;
  },

  setMagicLinkAuthData(authResponse: any, sessionData: any, practitionerType?: string) {
    // The verified visit wins over a legacy, editable URL query parameter.
    const specialty = sessionData.specialty || sessionData.practitioner_type || practitionerType;
    const data: StorageData = {
      access_token: authResponse.access_token,
      refresh_token: authResponse.refresh_token,
      user: {
        id: sessionData.patient_id,
        phone_no: authResponse.user_info.phone_no,
        is_verified: true,
        is_patient: authResponse.user_info.is_patient,
        name: authResponse.user_info.name,
        preferred_name: authResponse.user_info.preferred_name,
        email: authResponse.user_info.email,
        age: authResponse.user_info.age,
        date_of_birth: authResponse.user_info.date_of_birth,
        gender: authResponse.user_info.gender,
        country: authResponse.user_info.country,
        clinic_id: authResponse.user_info.clinic_id,
        is_admin: authResponse.user_info.is_admin,
        is_super_admin: authResponse.user_info.is_super_admin,
        is_medical_officer: authResponse.user_info.is_medical_officer,
      },
      session: {
        id: sessionData.session_id,
        status: 'active',
        start_time: new Date().toISOString(),
        magic_link_session_id: sessionData.session_id,
        patient_id: sessionData.patient_id,
        specialty,
        practitioner_type: specialty,
        language: sessionData.language,
        multilingual_consult: sessionData.multilingual_consult,
      }
    };
    this.setAuthData(data);
  }
};
